import { usePlaces } from '@/hooks/usePlaces';
import { PlaceCard } from '@/components/PlaceCard';
import { useContacts } from '@/hooks/useContacts';
import { EmergencyIcon, PhoneIcon } from '@/components/Icons';
import { formatPhone } from '@/lib/formatting';

export function EmergencyPage() {
  const { places } = usePlaces('medical');
  const { contacts } = useContacts();
  const er = (places ?? []).filter((p) => p.subcategory === 'emergency');
  const urgentCare = (places ?? []).filter((p) => p.subcategory === 'urgent_care');
  const emergencyContacts = contacts.filter((c) => c.category === 'emergency');

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Emergency</h1>
      </div>

      <div className="card" style={{ background: 'var(--color-pine)', color: '#fff' }}>
        <h2 style={{ color: '#fff', display: 'flex', alignItems: 'center', gap: 6 }}>
          <EmergencyIcon />
          Life-Threatening Emergency
        </h2>
        <p style={{ color: 'var(--color-sand)', fontSize: 14, margin: '8px 0 12px' }}>
          Chest pain, difficulty breathing, stroke symptoms, severe bleeding, or anything life-threatening.
        </p>
        <a href="tel:911" className="btn btn-block" style={{ background: '#fff', color: 'var(--color-pine)' }}>
          Call 911
        </a>
      </div>

      <div className="section-title">Nearest Emergency Rooms</div>
      {er.map((p) => (
        <PlaceCard key={p.id} place={p} detailed />
      ))}

      <div className="section-title">Urgent Care (non-life-threatening)</div>
      {urgentCare.map((p) => (
        <PlaceCard key={p.id} place={p} detailed />
      ))}

      {emergencyContacts.length > 0 && (
        <div className="card">
          <h2>
            <PhoneIcon style={{ verticalAlign: 'middle', marginRight: 6 }} />
            Emergency Contacts
          </h2>
          {emergencyContacts.map((c) => (
            <a key={c.id} href={c.phone ? `tel:${c.phone}` : undefined} className="list-row">
              <span>
                {c.name}
                <br />
                <small style={{ color: 'var(--color-ink-muted)' }}>{c.role}</small>
              </span>
              <span>{formatPhone(c.phone)}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
